import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
let weigthUnitMeasure;
addEventListener('setWeigthUnitMeasure', (e) => {
    const ce = e;
    weigthUnitMeasure = ce.detail.weigthUnitMeasure;
});
export const VITAL_SIGN_WEIGHT_UNIT_MEASURE_VALIDATOR = 'vital-sign-weight-unit-measure-validator';
async function vitalSignWeightUnitMeasureValidator(value) {
    let valid = false;
    let message = '';
    if (weigthUnitMeasure && weigthUnitMeasure.cd?.length > 0) {
        if (typeof value === 'string') {
            valid = (value.length > 0 && parseFloat(value) >= 0);
        }
        else {
            valid = (value || value >= 0);
        }
    }
    else {
        valid = true;
    }
    if (!valid) {
        message = MessageService.translate('message.weight-according-to-unit-selected');
    }
    weigthUnitMeasure = undefined;
    return [{
            message: message,
            name: VITAL_SIGN_WEIGHT_UNIT_MEASURE_VALIDATOR,
            valid: valid
        }];
}
export default vitalSignWeightUnitMeasureValidator;
//# sourceMappingURL=vital-sign-weigth-validator.js.map